module.exports = __webpack_public_path__ + "img/avtar.bd921d0d.svg";